<template>
  <div>
    <!--城市选择-->
    <div class="city-list" :class="{'adjust':adjust}">
        <div class="city-list-tab">
            <div v-for="(item,index) in cityList" :key="item.name" :class="{'active':cityIndex==index}" @click.stop="changeCity(index,item.name)">
                {{ item.name }}
            </div>
        </div>
        <div v-for="item in hotCityList" :key="item.name" class="city-list-content" >   
            <div class="city-list-content-title">{{ item.name }}</div>
            <ul  class="city-list-content-list">
                <li v-for="city in item.cityList" :key="city.title" @click.stop="selectCity(city)" :class="{'active':city.title==searcValue.cityName}">{{ city.title }}</li>
            </ul>
        </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'CitySelection',
  components: {},
  props: {
    //城市列表
    infoLise: {
        type:Object,
        default:()=>{}
    },
    //搜索值
    searcValue:{
        type:Object,
        default:()=>{}
    },
    //切换样式
    adjust:{
        type:Boolean,
        default:false
    }
  },
  data() {
    return {
        cityList: [
            {name:'热门城市'},
            {name:'ABCD'},
            {name:'EFGH'},
            {name:'JKLM'},
            {name:'NPQR'},
            {name:'STWX'},
            {name:'YZ'},
        ],
        cityIndex:0,
        hotCityList: [],
    };
  },
  computed: {},
  watch: {
    infoLise: {
        handler(newVal,oldVal){
            console.log(newVal,666);
            if(newVal){
                this.hotCityList = [ {name:'热门',cityList:newVal.hot}];
            }
        },
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    ...mapActions(['POST_GetAllCity']),
    //切换城市
    changeCity(index,name){
        let hotCityList=[];
        if(name=='热门城市'){
            hotCityList = [ {name:'热门',cityList:this.infoLise.hot}];
        }else{
            let str = name.split("");
            str.map(item=>{
                hotCityList.push({
                    name:item,
                    cityList:this.infoLise.info[item]
                })
            });
        }
        this.hotCityList = hotCityList;
        this.cityIndex = index;
    },
    //选择城市
    selectCity(data){
        this.$emit('formData',{city:data.city,cityName:data.title,cityId:data.id});
    },
    //获取热门城市列表
    // async getHotCity(){
    //     let res = await this.POST_GetAllCity({});
    //     if (res.code === '00000'){
    //         this.hotCityList =[ {name:'热门',cityList:res.hot}] ;
    //         this.infoLise = res;
    //     }
    // }
  }
};
</script>

<style lang="scss" scoped>
.city-list{
    position: absolute;
    top: 70px;
    left: 0;
    width: 900px;
    background-color: #Fff;
    border-radius: 6px;
    box-shadow: 0 2px 9px #999;
    z-index: 9;
}
.adjust{
    top:50px;
    --tw-shadow: 0 0 15px 0px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow:  var(--tw-shadow);
}
.city-list::after {
  content: "";
    position: absolute;
    top: -12px;     /* 贴在底部 */
    left: 70px;     /* 水平居中 */
    margin-left: -6px;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
}
.city-list-tab{
    width: 96%;
    padding: 2%;
    color: #666;
    display: flex;

}
.city-list-tab div{
    width: 50%;
    text-align: center;
    line-height: 20px;
    cursor: pointer;
}
.city-list-tab .active{
    color: var(--smtc-color-primary); 
    font-weight: bold;
}

.city-list-content{
    color: #333;
    display: flex;
    width: 96%;
    padding: 12px 2%;
    border-top: 1px #eee solid; 
}
.city-list-content-title{
    width: 5%;
    line-height: 24px;
    color:var(--smtc-color-primary)
}
.city-list-content-list{
    width: 95%;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
}
.city-list-content-list li{
    width: 10%;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
}
.city-list-content-list li:hover{
    color: var(--smtc-color-primary); 
}
.city-list-content-list .active{
    color: var(--smtc-color-primary); 
}
</style>
